<script setup lang="ts">
import { getFullName } from '@/helpers/index'
import type { CustomerContact } from '@/types/rc/customers/CustomerContactDetails'

defineProps<{ contact: CustomerContact }>()
</script>

<template>
  <el-descriptions :column="1">
    <!-- <el-descriptions-item label="Company">{{
      props.contact?.company_name || '-'
    }}</el-descriptions-item> -->
    <el-descriptions-item label="Name">{{
      getFullName(contact?.first_name, contact?.last_name) || '-'
    }}</el-descriptions-item>
    <el-descriptions-item label="Phone">{{ contact?.phone ?? '-' }}</el-descriptions-item>
    <el-descriptions-item label="Email">{{ contact?.email ?? '-' }}</el-descriptions-item>
  </el-descriptions>
</template>

<style scoped>
::v-deep(.el-descriptions__cell) {
  display: inline-flex;
}

::v-deep(.el-descriptions__label) {
  width: 148px;
}
</style>
